import $ from "jquery";

// import Swiper JS
import Swiper, { Navigation, Pagination, Autoplay } from 'swiper';
// configure Swiper to use modules
Swiper.use([Navigation, Pagination, Autoplay]);


$(function () {

    $.fn.sliderAcf = function () {
         new Swiper(  this[0] , {
            // Optional parameters
            loop: false,
            slidesPerView: '1',
            centeredSlides: false,
            grabCursor: true,
            // Navigation arrows
            navigation: {
                nextEl: this.parent().find('.swiper-button-next')[0],
                prevEl: this.parent().find('.swiper-button-prev')[0],
            },

            breakpoints: {

                // when window width is >= 640px
                640: {
                    slidesPerView: '4'
                }
            }

        });
    };

});